import React from 'react';
import { noop } from 'lodash';
/**
 * @note This component still uses `react-bootstrap`'s Panel component.
 * Not to be confused with `./Panel.jsx`
 */
import { Panel } from 'react-bootstrap';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import { LIMITED_READ } from '../../../constants/AccountCapability';
import AccountsStore from '../../../stores/AccountsStore/AccountsStore';
import SvgIcon from '../../common/SvgIcon';
import { BalancePreviousBusinessDay } from './BalancePreviousBusinessDay';
import { ClearedBalance } from './ClearedBalance';
import { CreditCardStatementDate } from './CreditCardStatementDate';
import { IBANAndBICDisplay } from './IBANAndBICDisplay';
import ProductUtils from '../../../utils/ProductUtils';

const { isRegularSaverProductCode760, isRegularSaverProductCode632 } =
  ProductUtils;

export const PanelData = ({
  accountId,
  account,
  balances,
  collapsibleButtonName,
  iconId,
  open,
  onShowMoreClick = noop,
  onFAQAnchorClick = noop,
  content = {},
}) => {
  const accountDetailsLoaded =
    AccountsStore.getAccountDetailsLoadedFlag(accountId);

  const accountDetailsError = AccountsStore.getAccountDetailsInError(accountId);

  const isRegularSaver = isRegularSaverProductCode760(account?.product?.code);
  const isRegularSaver632 = isRegularSaverProductCode632(
    account?.product?.code
  );

  return account.actionsAvailable[LIMITED_READ] ? null : (
    <div className="account-summary__more cardsticky__hide">
      <button
        id="ShowMore"
        role="link"
        aria-expanded={open}
        onClick={onShowMoreClick}
        className={`c-btn c-btn--link account-summary__more__btn`}
      >
        {collapsibleButtonName}
        <SvgIcon
          id={`${iconId}`}
          width="10px"
          height="10px"
          className="account-summary__more__btn__icon"
        />
      </button>
      <Panel expanded={open}>
        <Panel.Collapse>
          <Panel.Body>
            <LoadingLocalTakeover
              show={!accountDetailsLoaded && !accountDetailsError}
              title="loading..."
            >
              {account.type === 'credit_card' &&
                account.accountDetails.statementFlag && (
                  <CreditCardStatementDate account={account} />
                )}
              <ClearedBalance
                accountDetails={account}
                balances={balances}
                onFAQAnchorClick={onFAQAnchorClick}
                content={content}
              />
              <BalancePreviousBusinessDay
                account={account}
                balances={balances}
              />
              <IBANAndBICDisplay account={account} content={content} />
              <p
                className={`account-summary__more__contactinfo cardsticky__hide${
                  isRegularSaver || isRegularSaver632 ? ' regularsaver' : ''
                }`}
              >
                {isRegularSaver632
                  ? content.accountBalanceRegularSaver632
                  : isRegularSaver
                  ? /**
                     * @note The API should really surface Annual Equivalent Rate (AER)
                     * for Regular Saver, but only the Gross Interest Rate is available.
                     * This business requirement is to display Regular Saver's AER rate.
                     * To get round this limitation in this instance, AER rate is part of the `accountBalanceRegularSaver` content string.
                     * @todo Regular Saver 2.0 should surface the AER in the Account Details response
                     * @see https://enterprisevm.atlassian.net/browse/PB-8801
                     */
                    content.accountBalanceRegularSaver
                  : content.accountBalanceContactUs}
              </p>

              {/**
               * @note The API should really surface Annual Equivalent Rate (AER)
               * for Regular Saver, but only the Gross Interest Rate is available.
               * This business requirement is to display Regular Saver's AER rate.
               * To get roudn this limitation in this instance, AER rate is part of the `accountBalanceRegularSaver` content string.
               * @todo Regular Saver 2.0 should surface the AER in the Account Details response
               * @see https://enterprisevm.atlassian.net/browse/PB-8801
               */}
            </LoadingLocalTakeover>
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    </div>
  );
};
